/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import prettierBytes from 'prettier-bytes';
import { MIME_TYPE_TO_DISPLAY_NAME } from '@medflex/utils/constants';
import { EyeIcon, IdentificationIcon, ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import RenderFileIcon from '../RenderFileIconModule';

const mimeTypeToDisplayName = mimeType => MIME_TYPE_TO_DISPLAY_NAME[mimeType] || mimeType;

const FileValue = ({
  file,
  onOpenFile = () => {},
  onDownloadFile = () => {},
  onWriteExamination = null,
  showActionButtons = false,
}) => {
  const { t } = useTranslation('components', { keyPrefix: 'PamInquiry.FileValue' });
  const fileType = file.mediaType || file.type;
  const size = file.bytes || file.size;

  const buttonCn =
    'text-blue-500 hover:text-blue-700 bg-transparent hover:bg-slate-100 px-1 rounded-md text-sm flex flex-col items-center justify-center';

  return (
    <div key={`FileMessage_File${file.id}`} className="flex p-4 bg-slate-50 flex-col @md:flex-row">
      <div className="flex mb-2  items-center  w-fit grow-0 first:ml-0 rounded">
        <div className="text-green-500 flex">{fileType && <RenderFileIcon mime={fileType} />}</div>
        <div className="mx-2 overflow-hidden flex flex-col items-start">
          <div className="whitespace-normal text-sm text-left break-all text-slate-900 truncate max-w-full hover:underline focus:underline">
            {file.name}
          </div>
          <p className="text-slate-500 text-sm">
            {size && <span>{prettierBytes(size)}</span>}
            <span className="px-1">/</span>
            {fileType && <span>{mimeTypeToDisplayName(fileType)}</span>}
          </p>
        </div>
      </div>
      {showActionButtons && (
        <>
          <div className="w-full border-t border-gray-300 my-4 @md:my-0 @md:mx-4 @md:w-0 @md:h-full @md:border-t-0 @md:border-l" />
          <div className="flex flex-row content-center justify-between space-x-4">
            <button onClick={() => onOpenFile(file)} type="button" className={buttonCn}>
              <EyeIcon className="h-6 w-6" />
              <span className="text-sm whitespace-nowrap">{t('open')}</span>
            </button>
            <button onClick={() => onDownloadFile(file)} type="button" className={buttonCn}>
              <ArrowDownTrayIcon className="h-6 w-6" />
              <span className="text-sm whitespace-nowrap">{t('save')}</span>
            </button>
            {onWriteExamination && (
              <button onClick={() => onWriteExamination(file)} type="button" className={buttonCn}>
                <IdentificationIcon className="h-6 w-6" />
                <span className="text-sm whitespace-nowrap">{t('writeExamination')}</span>
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
};

FileValue.propTypes = {
  file: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    mediaType: PropTypes.string,
    type: PropTypes.string,
    bytes: PropTypes.number,
    size: PropTypes.number,
  }).isRequired,
  onOpenFile: PropTypes.func,
  onDownloadFile: PropTypes.func,
  onWriteExamination: PropTypes.func,
  showActionButtons: PropTypes.bool,
};

export default FileValue;
